import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';

const DEFAULT_SEARCH_DEBOUNCE = 500;

type ActiveSearchField = 'multiFieldSearch' | 'secondarySearch' | 'unset';

@Component({
  selector: 'search-toolbar',
  standalone: false,
  styleUrls: ['./search-toolbar.component.scss'],
  templateUrl: './search-toolbar.component.html',
})
export class SearchToolbarComponent implements OnDestroy {
  @Input() public currentMultiFieldSearchValue: string = '';
  @Input() public currentSecondarySearchValue: string = '';
  @Input() public debounce: number = DEFAULT_SEARCH_DEBOUNCE;
  @Input() public filterIsActive: boolean = false;
  @Input() public multiFieldSearchPlaceholderKey: string = 'VIEW.ORGANIZATION_LIST.SEARCH.MULTI_FIELD_PLACEHOLDER';
  @Input() public secondarySearchPlaceholderKey: string = 'VIEW.ORGANIZATION_LIST.SEARCH.PLACEHOLDER';
  @Input() public showLocationSearch: boolean = true;
  @Input() public searchOnInputChange: boolean = false;
  @Input() public showFilter: boolean = true;

  @Input() public showSkeleton: boolean = false;
  @Input() public isLoading: boolean = false;

  @Output() public filterClicked = new EventEmitter<void>();
  @Output() public multiFieldSearchInput = new EventEmitter<Event>();
  @Output() public secondarySearchInput = new EventEmitter<Event>();

  public activeSearchField: ActiveSearchField = 'unset';
  public debouncingField: ActiveSearchField = 'unset';

  private searchDebounceTimeout: ReturnType<typeof setTimeout> | null = null;

  public ngOnDestroy(): void {
    if (this.searchDebounceTimeout) {
      clearTimeout(this.searchDebounceTimeout);
      this.searchDebounceTimeout = null;
    }
  }

  public onFocus(field: ActiveSearchField): void {
    this.activeSearchField = field;
  }

  public onInputChange(event: Event, field: ActiveSearchField): void {
    if (this.activeSearchField !== field) {
      return;
    }

    if (!this.searchOnInputChange) {
      this.emitInputByField(field, event);

      return;
    }

    if (this.searchDebounceTimeout) {
      clearTimeout(this.searchDebounceTimeout);
      this.searchDebounceTimeout = null;
    }

    this.debouncingField = field;

    this.searchDebounceTimeout = setTimeout(() => {
      this.emitInputByField(field, event);
      this.debouncingField = 'unset';
      this.searchDebounceTimeout = null;
    }, this.debounce);
  }

  public onBlur(): void {
    this.activeSearchField = 'unset';
  }

  public isFieldLoading(field: ActiveSearchField): boolean {
    return (this.isLoading && this.activeSearchField === field)
      || this.debouncingField === field;
  }

  private emitInputByField(field: ActiveSearchField, event: Event): void {
    if (field === 'multiFieldSearch') {
      this.multiFieldSearchInput.emit(event);

      return;
    }

    if (field === 'secondarySearch') {
      this.secondarySearchInput.emit(event);
    }
  }
}
